<template>
  <b-modal
      id="modal-inconsistencias"
      title="Inconsistências"
      size="md"
      centered
      hide-footer
      class="modal-inconsistencias"
      @hidden="closeModal"
      ref="modal"
  >
    <div v-if="loading" class="text-center py-4">
      <b-spinner class="spinner-border text-custom-blue" />
      <p class="mt-2 mb-0">Carregando inconsistências...</p>
    </div>

    <div v-else-if="parsedInconsistencias && parsedInconsistencias.length > 0">
      <ul class="mb-0 pl-3">
        <li v-for="inconsistencia in parsedInconsistencias" :key="inconsistencia.id_inconsistencia" class="mb-2">
          <strong>{{ inconsistencia.descricao }}</strong>
        </li>
      </ul>
    </div>
    
    <div v-else class="text-success">
      Nenhuma inconsistência encontrada.
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button variant="secondary" @click="closeModal">
          Fechar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BSpinner
} from 'bootstrap-vue';

export default {
  name: 'InconsistenciasModal',
  
  components: {
    BModal,
    BButton,
    BSpinner
  },
  
  props: {
    inconsistencias: {
      type: [String, Array],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  
  computed: {
    parsedInconsistencias() {
      if (!this.inconsistencias) return [];
      
      try {
        let parsed = [];

        if (Array.isArray(this.inconsistencias)) {
          parsed = this.inconsistencias;
        } else if (typeof this.inconsistencias === 'string') {
          parsed = JSON.parse(this.inconsistencias);
        }
        
        return [...parsed].reverse();
      } catch (error) {
        console.error('Erro ao fazer parse das inconsistências:', error);
        return [];
      }
    }
  },
  
  methods: {
    closeModal() {
      this.$bvModal.hide('modal-inconsistencias');
      this.$emit('closed');
    }
  }
}
</script>

<style scoped>
.modal-inconsistencias .modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

li {
  word-break: break-word;
}
</style>
